import { render, staticRenderFns } from "./CenterProgram.vue?vue&type=template&id=7f9921e1&"
import script from "./CenterProgram.vue?vue&type=script&lang=js&"
export * from "./CenterProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports